import { render, staticRenderFns } from "./input-radio-group.vue?vue&type=template&id=5be03f07&scoped=true&"
import script from "./input-radio-group.vue?vue&type=script&lang=js&"
export * from "./input-radio-group.vue?vue&type=script&lang=js&"
import style0 from "./input-radio-group.vue?vue&type=style&index=0&id=5be03f07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be03f07",
  null
  
)

export default component.exports